<template>
  <div class="article-container">
    <!-- 导航栏 -->
    <van-nav-bar
      fixed
      left-arrow
      @click-left="$router.back()"
      title="文章详情"
    ></van-nav-bar>
    <!-- /导航栏 -->

    <!-- 加载中 loading -->
    <van-loading v-if="loading" class="article-loading" />
    <!-- /加载中 loading -->

    <!-- 文章详情 -->
    <div class="detail">
      <h3 class="title">{{article.title}}</h3>
      <div class="author">
        <van-image :src="article.aut_photo" round width="1rem" height="1rem" fit="fill" />
        <div class="text">
          <p class="name">{{article.aut_name}}</p>
          <p class="time">{{article.pubdate | relative}}</p>
        </div>
        <van-button
          round
          size="small"
          type="info"
          @click="toggleFollow"
        >{{article.is_followed?'取消关注':'+ 关注'}}</van-button>
      </div>
      <div class="content">
        <div v-html="article.content"></div>
      </div>
      <van-divider>END</van-divider>
      <div class="zan">
        <van-button
        round
        size="small"
        hairline
        type="primary"
        plain
        @click="toggleLike"
        :icon="article.attitude===1?'good-job':'good-job-o' ">
        {{article.attitude===1?'取消点赞':'点赞'}}</van-button>
        &nbsp;&nbsp;&nbsp;&nbsp;
        <van-button
        round
        size="small"
        hairline
        type="danger"
        plain
        @click="toggleDisLike"
        icon="delete">
        {{article.attitude===0?'取消不喜欢':'不喜欢'}}
        </van-button>
      </div>
    </div>
    <!-- /文章详情 -->

    <article-comment :article-id='$route.params.id'></article-comment>

  </div>
</template>

<script>
import { reqGetArticleDetail, reqAddLike, reqDeleteLike, reqDeleteDislike, reqAddDislike } from '@/api/article.js'
import { reqFollowUser, reqUnFollowUser } from '@/api/user.js'
import ArticleComment from './comment.vue'
export default {
  name: 'ArticleIndex',
  data () {
    return {
      loading: true, // 控制加载中的 loading 状态
      article: { }
    }
  },
  components: {
    ArticleComment
  },
  created () {
    this.loadArticle()
  },
  methods: {
    async loadArticle () {
      const res = await reqGetArticleDetail(this.$route.params.id)
      //   console.log(res.data.data)
      this.article = res.data.data
      this.loading = false
    },
    async toggleFollow () {
      try {
        this.article.is_followed = !this.article.is_followed
        if (this.article.is_followed) {
          await reqUnFollowUser(this.article.aut_id)
          this.$toast.success('取消关注成功')
        } else {
          await reqFollowUser(this.article.aut_id)
          this.$toast.success('关注成功')
        }
        // this.$toast.success('操作成功')
      } catch (error) {
        console.log(error)
        this.$toast.fail('操作失败')
      }
    },
    async toggleLike () {
      if (this.article.attitude === 1) {
        const res = await reqDeleteLike(this.article.art_id.toString())
        console.log(res)
        this.article.attitude = -1
      } else {
        const res = await reqAddLike(this.article.art_id.toString())
        console.log(res)
        this.article.attitude = 1
      }
    },
    async toggleDisLike () {
      if (this.article.attitude === 0) {
        const res = await reqDeleteDislike(this.article.art_id.toString())
        console.log(res)
        this.article.attitude = -1
      } else {
        const res = await reqAddDislike(this.article.art_id.toString())
        console.log(res)
        this.article.attitude = 0
      }
    }
  }
}
</script>

<style lang='scss' scoped>
.article-container{
  position: absolute;
  left: 0;
  top: 0;
  overflow-y: scroll;
  width: 100%;
  height: 100%;
}
.article-loading {
  padding-top: 100px;
  text-align: center;
}
.error{
  padding-top: 100px;
  text-align: center;
}
.detail {
  padding: 50px 10px;
  .title {
    font-size: 16px;
  }
  .zan{
    text-align: center;
  }
  .author {
    padding: 10px 0;
    display: flex;
    .text {
      flex: 1;
      padding-left: 10px;
      line-height: 1.3;
      .name {
        font-size: 14px;
        margin: 0;
      }
      .time {
        margin: 0;
        font-size: 12px;
        color: #999;
      }
    }
  }
  .content {
    font-size:14px;
    overflow: hidden;
    white-space: pre-wrap;
    word-break: break-all;
    ::v-deep img{
      max-width:100%;
      background: #f9f9f9;
    }
  }
  .van-divider::after,
   .van-divider::before{
      // border: 1px solid #000;
      border-width: 10px 0 0;
      border-color: red;

}
}
</style>
